import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import externalTicketsService, { 
  type ExternalTicket, 
  type CreateExternalTicketRequest
} from '@/services/external-tickets.service';

// External tickets by parent ticket ID
export const useExternalTicketsByParent = (parentTicketId: string) => {
  return useQuery({
    queryKey: ['external-tickets', 'parent', parentTicketId],
    queryFn: () => externalTicketsService.getByParentTicketId(parentTicketId),
    enabled: !!parentTicketId,
  });
};

// Create external ticket mutation
export const useCreateExternalTicket = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ parentTicketId, data }: { 
      parentTicketId: string; 
      data: CreateExternalTicketRequest 
    }) => externalTicketsService.create(parentTicketId, data),
    onSuccess: (newTicket, variables) => {
      const { parentTicketId } = variables;
      
      // Invalidate and refetch external tickets for the parent ticket
      queryClient.invalidateQueries({
        queryKey: ['external-tickets', 'parent', parentTicketId]
      });
      
      // Also invalidate the parent ticket query to update counts
      queryClient.invalidateQueries({
        queryKey: ['tickets', parentTicketId]
      });
    },
  });
};